import React, { useEffect, useState, useRef } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import { useToken } from "../../../hooks/useToken";
import RefreshBalance from "./RefreshBalance";
import "./balances.css";

const GetBalance = ({
  token,
  fetchBal,
  customCss = "",
  settokenBal = () => {},
  dataRefetch = false,
}: any) => {
  const { getBalance, createViewingKey } = useToken();
  const [isLoading, setIsLoading] = useState(false);
  const [activeCoinBalance, setActiveCoinBalance] = useState<any>();
  // const isLoading = useRef<boolean>(false);

  useEffect(() => {
    fetchBalance(false);
  }, [token]);

  useEffect(() => {
    fetchBalance(true);
  }, [dataRefetch]);

  useEffect(() => {
    fetchBal(activeCoinBalance);
  }, [activeCoinBalance]);

  const fetchBalance = async (isRefreshing?: boolean) => {
    setIsLoading(true);
    const balance = await getBalance(token, isRefreshing);
    console.log("check", token, balance)
    setActiveCoinBalance(balance);
    if (balance !== null) {
      settokenBal(balance);
    }
    // balance, asset.token);
    setIsLoading(false);
  };

  const handleCreateViewingKey = async () => {
    setIsLoading(true);
    await createViewingKey(token);
    const balance = await getBalance(token);
    setActiveCoinBalance(balance);
    if (balance !== null) {
      settokenBal(balance);
    }
    setIsLoading(false);
  };

  return (
    <>
      {isLoading ? (
        <PulseLoader
          color="#1790FF"
          loading={true}
          // cssOverride={override}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : activeCoinBalance !== null ? (
        <>
          <span className={`wallet-balance numeric-font`}>
            {(activeCoinBalance * 1.0).toLocaleString("en-US")}
            <RefreshBalance token={token} onClick={() => fetchBalance(true)} />
          </span>
        </>
      ) : (
        <span
          className={`getBlance-button common-button ${customCss}`}
          onClick={handleCreateViewingKey}
        >
          Get Balance
        </span>
      )}
    </>
  );
};

export default GetBalance;
